import { syncAllDbCachesFromState } from './dbIndexedCache';

/** Persist Redux state to IndexedDB and reset the 3-minute TTL for all hotel caches. */
export const syncAppDbCache = () => {
  // Lazy-load store to avoid circular init: store → global → pages/hooks → Settings/hooks → this file
  const { store } = require('redux/store') as typeof import('redux/store');
  syncAllDbCachesFromState(store.getState());
};
